import {fonts} from '../../../../theme/foundations/fonts'
import sizes from '../../../../theme/foundations/sizes'
import {pxToRem} from '../../../../utills/pxToRem'

export const informationAccordionStyle = {
    borderStyle: 'none',
    marginTop: pxToRem(31),
    color: 'black',
    [`@media (max-width: ${sizes.container.md})`]: {
        marginTop: pxToRem(21)
    }
}

export const accordionHeadingStyle = {
    fontFamily: fonts.primary,
    fontSize: pxToRem(16),
    fontWeight: '500',
    letterSpacing: pxToRem(1),
    [`@media (max-width: ${sizes.container.md})`]: {
        fontSize: pxToRem(14)
    }
}

export const accordionPanelStyle = {
    padding: '0px',
    fontFamily: fonts.primary,
    fontSize: pxToRem(16),
    fontWeight: '400',
    [`@media (max-width: ${sizes.container.md})`]: {
        fontSize: pxToRem(14)
    },
    p: {
        letterSpacing: pxToRem(1)
    },
    ul: {
        paddingLeft: pxToRem(20),
        marginTop: pxToRem(10),
        marginBottom: pxToRem(10),
        fontFamily: fonts.primary,
        li: {
            fontSize: pxToRem(16),
            fontWeight: 400,
            [`@media (max-width: ${sizes.container.md})`]: {
                fontSize: pxToRem(14)
            }
        }
    },
    'a button': {
        padding: `${pxToRem(12)} ${pxToRem(42)}`,
        lineHeight: pxToRem(18),
        backgroundColor: 'cav_dark_red',
        colorColor: 'transparent',
        color: 'cav_deep_light_gray',
        transition: 'all 0.3s ease',
        textAlign: 'center',
        fontWeight: 700,
        fontSize: pxToRem(14),
        textTransform: 'uppercase'
    },
    'a button:hover': {
        backgroundColor: 'cav_hover_brightred'
    },
    // Content asset specific styles
    '#cav-physicalgift-info ul li': {
        listStyle: 'disc !important',
        marginLeft: `${pxToRem(0)} !important`
    }
}

export const styleIdContainer = {
    marginTop: pxToRem(16),
    paddingLeft: pxToRem(19)
}

export const styleIdText = {
    fontFamily: fonts.primary,
    fontWeight: '500',
    fontSize: pxToRem(16),
    color: 'black',
    margin: 0
}

export const iconStyle = {
    width: pxToRem(17),
    height: pxToRem(17)
}
